import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISidebar, SidebarService } from '../sidebar/sidebar.service';
import { SessionService } from './../../../shared/session.service';
import { NotificationService } from 'src/app/@services/notifications.service';
import { SocketIoService } from 'src/app/@services/socketIo.service';
import { SubscriptionService } from 'src/app/@services/subscription.service';
import { Enum } from '@common/enums/enum';
import { getEnumKeyByValue } from 'src/app/shared/utility.functions';
import { ReadOnlyService } from '@app/shared/readonly.service';
import * as moment from 'moment';
import { subscriptionDetail, subscriptionUsageForTopNav } from '@common/projection/subscription.projection';
import { CompanyUserService } from '@app/@services/company-user.service';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],

})
export class TopnavComponent implements OnInit, OnDestroy {
  companyId: any;
  adminRoot = environment.adminRoot;
  sidebar: ISidebar;
  subscription: Subscription;
  displayName: any = '';
  selectedCompany: any;
  currentLanguage: string;
  isSingleLang: any;
  searchKey = '';
  userCompanies: any[] = [];
  filteredUserCompanies: any[] = [];
  companiesToDisplay: any[] = [];
  bsModalRef: BsModalRef;
  companyLogo = '';
  result: any;
  isSeeMore: boolean = false;
  moreCompany: boolean = false;
  notificationCount: number = 0;
  notificationsArray: any[] = [];
  subscriptions: any[] = [];
  subscriptionsUsage: any;

  constructor(
    private sidebarService: SidebarService,
    private companyUserService: CompanyUserService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private socketIoService: SocketIoService,
    private notificationsService: NotificationService,
    private subscriptionService: SubscriptionService,
    private _readOnly: ReadOnlyService
  ) { }

  setImage(data: any) {
    if (data?.logo && data?.logo != "") {
      let logo = environment.apiUrl + data.logo;
      this.companyLogo = logo.replace("\\", "/");
    } else {
      this.companyLogo = "../assets/images/icons8-user-64.png";
    }
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      this.companyId = params['companyId'];
    });

    this.subscription = this.sidebarService.getSidebar().subscribe((res) => {
      this.sidebar = res;
    },
      (err) => {
        console.error(`An error occurred: ${err.message}`);
      });

    await this.getUserCompanies();

    const user = JSON.parse(localStorage.getItem('currentUser'));
    const companyId = localStorage.getItem('companyId');
    this.notificationsArray = await this.socketIoService.getOrdersNotifications(user);
    this.notificationCount = this.notificationsArray.length;


    await this.getSubscriptions(companyId);
    await this.getSubscriptionUsageData(companyId);

    // let socket = getSocketIOConnection();

    // socket.on("orderNotify", async (res) => {
    //   this.notificationRender(res)
    // });


    // socket.on("logisticNotify", (res) => {
    //   this.notificationRender(res)
    // });


    // socket.on("warehouseNotify", (res) => {
    //   this.notificationRender(res)
    // });


  }

  notificationRender(res) {
    const companyId = localStorage.getItem('companyId');
    for (let i = 0; i < res.length; i++) {
      if (res[i].companyId == companyId) {
        this.notificationCount += 1;
        this.notificationsArray.unshift(res[i]);
      }
    };

  }


  async getSubscriptions(companyId: string) {

    const result = await this.subscriptionService.getSubscriptionByStatus(subscriptionDetail, companyId, [Enum.subscriptionStatus.pending, Enum.subscriptionStatus.expired]);
    if (result?.IsSuccess) {
      this.subscriptions = result?.Data;
    }
  }

  async getSubscriptionUsageData(companyId: string) {

    const result = await this.subscriptionService.getSubscriptionUsageData(subscriptionUsageForTopNav, companyId);
    if (result?.IsSuccess) {
      this.subscriptionsUsage = result?.Data;
    }

  }

  async closeAlert(index: any) {

    this.subscriptions.splice(index, 1);

  }

  getPlanType(type: number) {

    return getEnumKeyByValue(
      Enum.subscriptionPlanType,
      type
    ).toUpperCase();

  }

  async markNotificationsAsRead() {
    var timezone = moment.tz.guess();
    let currentDay = new Date();
    let twoDaysBefore = new Date();
    twoDaysBefore.setDate(twoDaysBefore.getDate() - 2)
    let data = {
      fromDate: twoDaysBefore.toString(),
      toDate: currentDay.toString(),
      timezone: timezone
    }
    await this.notificationsService.markAllAsRead(data);
    this.notificationCount = 0;
    this.notificationsArray = [];
  }

  async getUserCompanies() {
    this.result = await this.companyUserService.getUserCompanies();
    this.userCompanies = this.result?.Data;
    this.filteredUserCompanies = this.result?.Data;
    if (this.userCompanies) {
      await this.selectCompany(this.companyId);
    }
    if (this.result?.Data?.length >= 6) {
      this.moreCompany = true;
    }
  }

  async selectCompany(selectedCompanyId: string) {

    let inSessionCompanyId = localStorage.getItem('companyId');
    this.selectedCompany = this.userCompanies?.find((o) => (o.companyId === (selectedCompanyId ? selectedCompanyId : inSessionCompanyId)) || (o.companyId === inSessionCompanyId));
    if (!this.selectedCompany || this.selectedCompany == null) this.selectedCompany = this.userCompanies[0];

    let currentCompanyId = this.selectedCompany?.companyId;
    this.filteredUserCompanies = this.userCompanies.filter(f => f.companyId != this.selectedCompany?.companyId);
    this.companiesToDisplay = this.filteredUserCompanies.slice(0, 4);
    localStorage.setItem('companyId', currentCompanyId);
    this.setImage(this.selectedCompany);
    if (selectedCompanyId) {

      this.router.navigate(['/app/dashboards/default']);
      return;
    }
  }

  async activateCompany(item: any) {
    this.selectedCompany = item;
    this.isSeeMore = false;
    this.filteredUserCompanies = this.userCompanies.filter(f => f.companyId == item.companyId);
    localStorage.setItem('companyId', item.companyId);
    localStorage.setItem('dateFormat', item.dateFormat ? item.dateFormat : 'DD/MM/YYYY');
    await this.setCompanySettingOnLocalStorage();
    this.router.navigate(['/app/dashboards/default']).
      then(() => window.location.reload());
    this.ngOnInit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  menuButtonClick = (
    e: { stopPropagation: () => void },
    menuClickCount: number,
    containerClassnames: string
  ) => {
    if (e) {
      e.stopPropagation();
    }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);

    this.sidebarService.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.sidebar.selectedMenuHasSubItems
    );
  };

  mobileMenuButtonClick = (
    event: { stopPropagation: () => void },
    containerClassnames: string
  ) => {
    if (event) {
      event.stopPropagation();
    }

    this.sidebarService.clickOnMobileMenu(containerClassnames);
  };

  onSignOut(): void {
    this.sessionService.logoutSession();
  }

  topNav(menu: string) {
    switch (menu) {
      case 'AddCompany':
        this.router.navigate(['/user/company']);
        break;
      case 'CompanySetting':
        this.router.navigate(['/company/setting']);
        break;
      case 'Subscription':
        this.router.navigate(['app/subscription/subscription-list']);
        break;
      case 'Warehouses':
        this.router.navigate(['/app/Setup/warehouse']);
        break;
      case 'Cities':
        this.router.navigate(['/app/Setup/city']);
        break;
      case 'Countries':
        this.router.navigate(['/app/Setup/country']);
        break;
      case 'Customers':
        this.router.navigate(['/app/Setup/customer']);
        break;
      case 'ChangePassword':
        this.router.navigate(['/user/change-password']);
        break;
      case 'UserProfile':
        this.router.navigate(['/app/user-profile']);
        break;
      default:
        break;
    }
  }

  searchKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    }
    else if (event.key === 'Escape') {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) {
        input.classList.remove('mobile-view');
      }

      this.searchKey = '';
    }
  }

  searchAreaClick(event): void {
    event.stopPropagation();
  }

  searchClick(event): void {
    if (window.innerWidth < environment.menuHiddenBreakpoint) {
      let elem = event.target;
      if (!event.target.classList.contains('search')) {
        if (event.target.parentElement.classList.contains('search')) {
          elem = event.target.parentElement;
        } else if (
          event.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = event.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
      } else {
        elem.classList.add('mobile-view');
      }
    } else {
      this.search();
    }
    event.stopPropagation();
  }

  search(): void {
    if (this.searchKey && this.searchKey.length > 1) {
      this.router.navigate([this.adminRoot + '/pages/miscellaneous/search'], {
        queryParams: { key: this.searchKey.toLowerCase().trim() },
      });

      this.searchKey = '';
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event): void {
    const input = document.querySelector('.mobile-view');
    if (input && input.classList) {
      input.classList.remove('mobile-view');
    }
    this.searchKey = '';
  }

  clickSeeMore() {
    this.isSeeMore = true
    this.companiesToDisplay = this.userCompanies.filter(f => f.companyId != this.selectedCompany.companyId);
    this.moreCompany = false;
  }

  clickHide() {
    this.isSeeMore = false;
    this.companiesToDisplay = this.filteredUserCompanies.slice(0, 4);

    if (this.result?.Data?.length >= 6) {
      this.moreCompany = true;
    }
  }

  async setCompanySettingOnLocalStorage() {

    const companySetting = await this._readOnly.getCompanySetting();
    localStorage.setItem('companySetting', JSON.stringify(companySetting));

  }
}
